{
  "AgentDetails_GUID": "Identifier (GUID):",
  "AgentNumber": "Agentnummer:",
  "AgentDetails_Partition": "Verdeling:",
  "AgentDetails_Description": "Beschrijving:",
  "AgentDetails_UpdateExistingItems": "Dubbele items bijwerken:",
  "AgentDetails_GUIDPlaceholder": "[Auto Toegewezen]",
  "AgentDetails_Validation_GUID": "De maximale lengte van een GUID is 100 tekens",
  "AgentDetails_Validation_AgentNumber": "Er moet een agentnummer worden opgegeven",
  "AgentDetails_Validation_Partition": "Er moet een partitie worden geselecteerd",
  "AgentDetails_NonePartition": "[Geen]",
  "NAME": "AgentDetails"
}